import { render } from "./InventoryContainerComponent.vue?vue&type=template&id=13fa453b"
import script from "./InventoryContainerComponent.vue?vue&type=script&lang=js"
export * from "./InventoryContainerComponent.vue?vue&type=script&lang=js"

import "./InventoryContainerComponent.vue?vue&type=style&index=0&id=13fa453b&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__